export default __webpack_public_path__ + "static/media/personalIcon.6d56288d.jpg";